const isValidImageURL = (url) => url?.match(/\.(jpeg|jpg|gif|png)$/) !== null;

export default isValidImageURL;
